import { useEffect, useRef, useState } from "react";
import Footer from "../components/Footer";

const INTERIOR_LOGO = "https://customer-assets.emergentagent.com/job_vandys-gallery/artifacts/yzw4p2l5_WhatsApp%20Image%202026-04-18%20at%2000.32.25.jpeg";

const INTERIOR_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_vandys-gallery/artifacts/18m58j3q_WhatsApp%20Image%202026-04-11%20at%2014.06.48.jpeg",
  "https://customer-assets.emergentagent.com/job_vandys-gallery/artifacts/lp9s7hiq_WhatsApp%20Image%202026-04-11%20at%2014.06.47%20%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_vandys-gallery/artifacts/9u3fl9yk_WhatsApp%20Image%202026-04-11%20at%2014.06.47.jpeg",
  "https://customer-assets.emergentagent.com/job_vandys-gallery/artifacts/5yxqq74p_WhatsApp%20Image%202026-04-11%20at%2014.06.46.jpeg",
  "https://customer-assets.emergentagent.com/job_vandys-gallery/artifacts/ivgf1sqw_WhatsApp%20Image%202026-04-11%20at%2014.06.45.jpeg",
];

function FloatingPhoto({ src, style, speed, phase }) {
  const ref = useRef(null);

  useEffect(() => {
    let frame;
    const animate = () => {
      if (!ref.current) return;
      const t = Date.now() / 1000;
      const y = Math.sin(t * speed + phase) * 18;
      const x = Math.cos(t * speed * 0.6 + phase) * 12;
      const rot = Math.sin(t * speed * 0.35 + phase) * 6;
      ref.current.style.transform = `translate(${x}px, ${y}px) rotate(${rot}deg)`;
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [speed, phase]);

  return (
    <div
      ref={ref}
      className="absolute pointer-events-none"
      style={{ ...style, willChange: "transform" }}
    >
      <div className="w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 rounded-xl overflow-hidden shadow-lg"
        style={{ filter: "brightness(0.9) saturate(0.8)", opacity: 0.7 }}
      >
        <img src={src} alt="" className="w-full h-full object-cover" draggable={false} />
      </div>
    </div>
  );
}

export default function InteriorPage() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMove = (e) => {
      setMousePos({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 15,
      });
    };
    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, []);

  const photoPositions = [
    { top: "8%", left: "5%", speed: 0.35, phase: 0 },
    { top: "10%", right: "6%", speed: 0.4, phase: 1.5 },
    { top: "45%", left: "4%", speed: 0.3, phase: 3 },
    { top: "50%", right: "5%", speed: 0.45, phase: 4.5 },
    { bottom: "10%", left: "50%", speed: 0.38, phase: 2 },
  ];

  return (
    <div data-testid="interior-page" className="pt-20 md:pt-24 min-h-screen relative overflow-hidden">
      {/* Floating interior photos in the body */}
      {INTERIOR_PHOTOS.map((src, i) => (
        <FloatingPhoto
          key={i}
          src={src}
          style={photoPositions[i]}
          speed={photoPositions[i].speed}
          phase={photoPositions[i].phase}
        />
      ))}

      {/* Center content with parallax */}
      <div
        className="relative z-10 flex flex-col items-center justify-center text-center px-6 min-h-[calc(100vh-180px)]"
        style={{
          transform: `translate(${mousePos.x * 0.3}px, ${mousePos.y * 0.3}px)`,
          transition: "transform 0.5s ease-out",
        }}
      >
        {/* Interior logo — blended with page bg, with shining red border outline */}
        <div
          className="mb-6 md:mb-8 rounded-xl overflow-hidden bg-[#F5E6A0] relative interior-logo-shine"
          data-testid="interior-logo-frame"
        >
          <img
            src={INTERIOR_LOGO}
            alt="Vandy's Interior"
            className="w-44 sm:w-60 md:w-80 h-auto relative z-10"
            style={{ mixBlendMode: "darken" }}
            data-testid="interior-logo"
          />
        </div>

        {/* Coming soon text */}
        <h1
          className="text-4xl sm:text-5xl md:text-7xl text-[#1A1A1A] mb-4"
          style={{ fontFamily: "'Lazy Dog', cursive" }}
          data-testid="coming-soon-heading"
        >
          coming soon
        </h1>
        <p
          className="text-lg md:text-xl text-[#E01A23] mb-6"
          style={{ fontFamily: "'Lazy Dog', cursive" }}
        >
          to chennai
        </p>
        <p
          className="text-sm text-[#3a3a3a] max-w-md leading-relaxed"
          style={{ fontFamily: "'Courier New', Courier, monospace" }}
        >
          vandy's interior — bringing original art and handcrafted design into your living spaces. stay tuned.
        </p>
      </div>
      <Footer />
    </div>
  );
}
